import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    root: {
      width: '100%',
      margin: 'auto',
      flex: 1,
    },
    item: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: '0',
    },
    createDocumentLink: {
      textDecoration: 'none',
    },
    buttons: {
      display: 'block',
      clear: 'both',
      height: 50,
    },
    actionsContainer: {
      padding: 20,
    },
    noPendingActions: {
      margin: theme.spacing(2),
    },
  }),
);
